export const V2_CODING_VERTICAL_RESIZE_EVENT = 'vertical:bill:coding';
export const V2_CODING_HORIZONTAL_RESIZE_EVENT = 'horizontal:bill:coding';
export const CREATE_ITEM_RESIZE_FILE_VIEWER_EVENT = 'create-item:resize:file-viewer';
export const ITEM_DETAILS_RESIZE_FILE_VIEWER_EVENT = 'item-details:resize:file-viewer';
export const lineItemHeaderHeight = 120;
